/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Card,
  FormLayout,
  Page,
  Text,
  TextField,
} from "@shopify/polaris";
import { Controller, useForm } from "react-hook-form";
import { TWO_FACTOR_FORM_TYPES } from "../store/types/TwoFac";
import { useVerifyAuthCodeMutation } from "../store/store/slices/ProfileRTK";
import { useNavigate, useSearchParams } from "react-router-dom";

const TwoFactorPage = () => {
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const twoFactorToken = searchParams?.[0]?.get("two_factor_token") || "";

  // HOOKS
  const [verifyCode, { isError, isLoading, error }] = useVerifyAuthCodeMutation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<TWO_FACTOR_FORM_TYPES>();

  // FUNCTIONS
  const verifyAuthCodeHandler = async (data: TWO_FACTOR_FORM_TYPES) => {
    const { code } = data;  // Extract the code from form data

    // Call mutation with both code and twoFactorToken
    const response = await verifyCode({ code, twoFactorToken });

    if (response?.data?.auth_token) {
      // Successfully authenticated, store the tokens
      localStorage.removeItem("auth_token");
      localStorage.setItem("auth_token", response?.data?.auth_token);
      if (response?.data?.refresh_token) {
        localStorage.setItem("refresh_token", response?.data?.refresh_token);
      }

      // Redirect to dashboard
      window.location.href = "/dashboard";
    }
  };

  return (
    <Page title="Two-factor authentication" narrowWidth>
      <Card>
        <FormLayout>
          <Controller
            control={control}
            name="code"
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                autoComplete="off"
                label="Enter authenticator code here"
                placeholder="XXXXXX"
                error={errors.code && "Code is required"}
              />
            )}
          />
          <div>
            <Button
              onClick={handleSubmit(verifyAuthCodeHandler)}
              disabled={isLoading}
              loading={isLoading}
            >
              Submit
            </Button>
          </div>
        </FormLayout>
        <div>
          <Text as="p" tone="critical">
            {isError && (error?.data?.msg || "Something went wrong")}
          </Text>
        </div>
      </Card>
    </Page>
  );
};

export default TwoFactorPage;
